import Dexie from 'dexie';

import { PhotoInUploadQueue } from '@models/*';
import { DB_OFFLINE_QUEUE_NAME, DB_OFFLINE_QUEUE_SCHEMA_V3, DB_OFFLINE_QUEUE_SCHEMA_V4 } from './drive/service-worker.constants.js';

interface StoredHttpRequest {
    type: 'post' | 'put' | 'delete';
    endpoint: string;
    payload: any;
    retryTotal: number;
    retryLatestDate: string;
    createdAt: string;
}

interface StoredPhotoRequest {
    payload: string;
    retryTotal: number;
    retryLatestDate: string;
    createdAt: string;
    transportInternalId: string;
}

interface StoredProtocolPhotoUploads {
    photos: PhotoInUploadQueue[];
    transportInternalId: string;
    createdAt: string;
}

export class OfflineQueueDB extends Dexie {
    public httpRequests: Dexie.Table<StoredHttpRequest, number>;
    public photoRequests: Dexie.Table<StoredPhotoRequest, number>;
    public protocolPhotoUploads: Dexie.Table<StoredProtocolPhotoUploads, number>;
    public jwt: Dexie.Table<string, number>;

    public constructor() {
        super(DB_OFFLINE_QUEUE_NAME);
        this.version(3).stores(DB_OFFLINE_QUEUE_SCHEMA_V3);
        this.version(4).stores(DB_OFFLINE_QUEUE_SCHEMA_V4);
        this.httpRequests = this.table('httpRequests');
        this.photoRequests = this.table('photoRequests');
        this.protocolPhotoUploads = this.table('protocolPhotoUploads');
        this.jwt = this.table('jwt');
    }
}

export const offlineQueueDB = new OfflineQueueDB;
